

















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import population from '@/interfaces/population.ts';
import _ from 'lodash';
import { colors, shadeColor } from './colors';

const shade = 25;

@Component({
  data() {
    return {
      index: 1,
      colorRow: 0,
      colorColumn: 7,
      mainColor: colors[0][7],
      rowSkip: 13,
      showAsAlleles: true,
      isAlleleAmountPristine: true,
      isDiploidAmountPristine: true,
      name: 'População 1',
      size: 0,
      amountA1: 0,
      amountA2: 0,
      amountA1A1: 0,
      amountA2A2: 0,
      amountBoth: 0,
      colorA1: shadeColor(colors[0][7], shade),
      colorA2: shadeColor(colors[0][7], -shade),
      colorA1A1: shadeColor(colors[0][7], shade),
      colorA2A2: shadeColor(colors[0][7], -shade),
      colorBoth: colors[0][7],
      frequencyA1: '0,50',
      frequencyA2: '0,50',
    };
  },
  mounted() {
    const that: any = this;
    that.updateLabels();
  },
  methods: {
    resetValues() {
      const that: any = this;
      const newIndex = that.index + 1;
      const newColorRow = (that.colorRow + that.rowSkip) % colors.length;
      const newMainColor = colors[newColorRow][that.colorColumn];
      Object.assign(that, {
        index: newIndex,
        colorRow: newColorRow,
        mainColor: newMainColor,
        name: `População ${newIndex}`,
        isAlleleAmountPristine: true,
        isDiploidAmountPristine: true,
        size: 0,
        amountA1: 0,
        amountA2: 0,
        amountA1A1: 0,
        amountA2A2: 0,
        amountBoth: 0,
        colorA1: shadeColor(newMainColor, shade),
        colorA2: shadeColor(newMainColor, -shade),
        colorA1A1: shadeColor(newMainColor, shade),
        colorA2A2: shadeColor(newMainColor, -shade),
        colorBoth: newMainColor,
        frequencyA1: '0,50',
        frequencyA2: '0,50',
      });

      Vue.nextTick(() => that.updateLabels());
    },
    updateLabels() {
      // @ts-ignore
      setTimeout(M.updateTextFields, 100);
    },
    getPercentageAmountA1() {
      const that: any = this;
      // const amountA1 = Number(that.amountA1);
      // const amountA2 = Number(that.amountA2);
      // const computedsize = amountA1 + amountA2;
      // if (that.isAlleleAmountPristine || computedsize === 0) {
      //   return 0.5;
      // }
      // return amountA1 / computedsize;
      return Number(that.frequencyA1.replace(',', '.'));
    },
    getPercentageAmountA2() {
      const that: any = this;
      return Number(that.frequencyA2.replace(',', '.'));
    },
    getPercentageAmountA1A1() {
      const that: any = this;
      // const amountA1A1 = Number(that.amountA1A1);
      // const amountA2A2 = Number(that.amountA2A2);
      // const amountBoth = Number(that.amountBoth);
      // const computedsize = amountA1A1 + amountA2A2 + amountBoth;
      // if (that.isDiploidAmountPristine || computedsize === 0) {
      //   return 0.25;
      // }
      // return amountA1A1 / computedsize;
      return Number(that.frequencyA2.replace(',', '.'));
    },
    getPercentageAmountA2A2() {
      const that: any = this;
      const amountA1A1 = Number(that.amountA1A1);
      const amountA2A2 = Number(that.amountA2A2);
      const amountBoth = Number(that.amountBoth);
      const computedsize = amountA1A1 + amountA2A2 + amountBoth;
      if (that.isDiploidAmountPristine || computedsize === 0) {
        return 0.25;
      }
      return amountA2A2 / computedsize;
    },
    onColorChange(event) {
      const that: any = this;
      const value = event.target.value;

      that.colorA1 =  shadeColor(value, shade);
      that.colorA2 =  shadeColor(value, -shade);
      that.colorA1A1 =  shadeColor(value, shade);
      that.colorA2A2 =  shadeColor(value, -shade);
      that.colorBoth =  value;
    },
    onSizeChange(value) {
      const that: any = this;
      value = Number(value);
      value = isNaN(value) ? 0 : value;
      value = value < 0 ? 0 : value;

      const percentageAmountA1 = that.getPercentageAmountA1();
      const percentageAmountA2 = that.getPercentageAmountA2();

      const amountA1A1 = Math.floor(percentageAmountA1 * percentageAmountA1 * value);
      const amountA2A2 = Math.floor(percentageAmountA2 * percentageAmountA2 * value);
      const amountBoth = value - amountA1A1 - amountA2A2;

      const amountA1 = amountA1A1 + amountA1A1 +  amountBoth;
      const amountA2 = amountA2A2 + amountA2A2 +  amountBoth;

      Object.assign(that, {
        size: value,
        amountA1,
        amountA2,
        amountA1A1,
        amountA2A2,
        amountBoth,
      });

      that.updateLabels();
    },
    onChangeFrequencyA1(event) {
      const that: any = this;
      let value = Number(event.target.value.replace(',', '.'));
      value = isNaN(value) ? 0.5 : value;
      value = value > 1 ? 1 : value;
      value = value < 0 ? 0 : value;

      let frequencyA1 = parseFloat(String(value)).toPrecision(2);
      // @ts-ignore
      let frequencyA2 = parseFloat(String(1 - frequencyA1)).toPrecision(2);

      frequencyA1 = String(frequencyA1).replace('.', ',');
      frequencyA2 = String(frequencyA2).replace('.', ',');

      Object.assign(that, {
        frequencyA2,
        frequencyA1,
      });

      Vue.nextTick(() => that.onSizeChange(that.size));
    },
    onChangeFrequencyA2(event) {
      Vue.nextTick(() => that.onSizeChange(that.size));

      const that: any = this;
      let value = Number(event.target.value.replace(',', '.'));
      value = isNaN(value) ? 0.5 : value;
      value = value > 1 ? 1 : value;
      value = value < 0 ? 0 : value;

      let frequencyA2 = parseFloat(String(value)).toPrecision(2);
      // @ts-ignore
      let frequencyA1 = parseFloat(String(1 - frequencyA2)).toPrecision(2);

      frequencyA1 = String(frequencyA1).replace('.', ',');
      frequencyA2 = String(frequencyA2).replace('.', ',');

      Object.assign(that, {
        frequencyA2,
        frequencyA1,
      });

      Vue.nextTick(() => that.onSizeChange(that.size));
    },
    onAmountA1Change(event) {
      // @ts-ignore
      const that: any = this;
      const value = Number(event.target.value);

      that.isAlleleAmountPristine = false;

      const amountA1 = value;
      let size = value + Number(that.amountA2);
      let amountA2 = that.amountA2;
      if (size % 2 === 1) {
        amountA2 = amountA2 + 1;
        size = size + 1;
      }

      Object.assign(that, {
        size,
        amountA1,
        amountA2,
      });

      Vue.nextTick(() => that.onSizeChange(Math.floor(size / 2)));
    },
    onAmountA2Change(event) {
      // @ts-ignore
      const that: any = this;
      const value = Number(event.target.value);

      that.isAlleleAmountPristine = false;

      const amountA2 = value;
      let size = value + Number(that.amountA1);
      let amountA1 = that.amountA1;
      if (size % 2 === 1) {
        amountA1 = amountA1 + 1;
        size = size + 1;
      }

      Object.assign(that, {
        size,
        amountA1,
        amountA2,
      });

      Vue.nextTick(() => that.onSizeChange(Math.floor(size / 2)));
    },
    onamountA1A1Change(event) {
      const that: any = this;
      const value = Number(event.target.value);

      that.isDiploidAmountPristine = false;
      that.amountA1A1 = value;
      that.size = value + Number(that.amountA2A2) + Number(that.amountBoth);

      Vue.nextTick(() => that.onSizeChange(that.size));
    },
    onAmountA2A2Change(event) {
      const that: any = this;
      const value = Number(event.target.value);

      that.isDiploidAmountPristine = false;
      that.amountA2A2 = value;
      that.size = value + Number(that.amountA1A1) + Number(that.amountBoth);

      Vue.nextTick(() => that.onSizeChange(that.size));
    },
    onAmountBothChange(event) {
      const that: any = this;
      const value = Number(event.target.value);

      that.isDiploidAmountPristine = false;
      that.amountBoth = value;
      that.size = value + Number(that.amountA1A1) + Number(that.amountA2A2);

      Vue.nextTick(() => that.onSizeChange(that.size));
    },
    onSubmit(event) {
      event.preventDefault();
      const that: any = this;

      // @ts-ignore
      const Toast = M.toast;
      const {
        name,
        size,
        amountA1,
        amountA2,
        amountA1A1,
        amountA2A2,
        amountBoth,
        colorA1,
        colorA2,
        colorA1A1,
        colorA2A2,
        colorBoth,
      }: any = that;
      let hasError = false;

      if (!name) {
        Toast({html: 'O nome da população não pode estar em branco'});
        hasError = true;
      }

      if (size <= 0) {
        Toast({html: 'O tamanho da população tem que ser maior que 0'});
        hasError = true;
      }

      if (hasError) {
        return;
      }

      const currentPopulation: population = {
        name,
        size,
        amountA1,
        amountA2,
        amountA1A1,
        amountA2A2,
        amountBoth,
        colorA1,
        colorA2,
        colorA1A1,
        colorA2A2,
        colorBoth,
      };
      this.$emit('add', currentPopulation);

      Vue.nextTick(() => that.resetValues());
    },
  },
})
export default class AddPopulation extends Vue {}
